export function MessagesCbsIcon(props) {
  return (
    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M18 4.5V9.9H16.2V4.5M16.2 11.7H18V13.5H16.2M8.1 0C7.62261 0 7.16477 0.189642 6.82721 0.527208C6.48964 0.864773 6.3 1.32261 6.3 1.8C6.29368 1.88689 6.29368 1.97411 6.3 2.061C3.708 2.826 1.8 5.238 1.8 8.1V13.5L0 15.3V16.2H16.2V15.3L14.4 13.5V8.1C14.4 5.238 12.492 2.826 9.9 2.061C9.90632 1.97411 9.90632 1.88689 9.9 1.8C9.9 1.32261 9.71036 0.864773 9.37279 0.527208C9.03523 0.189642 8.57739 0 8.1 0ZM6.3 17.1C6.3 17.5774 6.48964 18.0352 6.82721 18.3728C7.16477 18.7104 7.62261 18.9 8.1 18.9C8.57739 18.9 9.03523 18.7104 9.37279 18.3728C9.71036 18.0352 9.9 17.5774 9.9 17.1H6.3Z"
        fill="currentColor"
      />
    </svg>
  );
}
